export default __webpack_public_path__ + "static/media/favicon.f608897c.ico";